<template>
  <section class="list">
    <div class="row">
      <article
        class="card variety-card"
        v-for="variety in varieties"
        :key="variety"
        @click="selectVariety(variety)"
      >
        <div class="variety-body">
          <h3 class="variety-name">{{ variety }}</h3>
          <p class="variety-count">
            {{ countZones(variety) }} zona{{
              countZones(variety) !== 1 ? "s" : ""
            }}
          </p>
        </div>
      </article>
    </div>
  </section>
</template>

<script>
export default {
  name: "ListVarieties",

  props: {
    finca: {
      type: Object,
      required: true,
    },
  },

  computed: {
    varieties() {
      if (!this.finca || !Array.isArray(this.finca.zones)) return [];
      const names = this.finca.zones
        .map((z) => z.variety)
        .filter((v) => v !== null && v !== undefined && v !== "");
      return [...new Set(names)].sort();
    },
  },

  methods: {
    countZones(variety) {
      if (!this.finca || !Array.isArray(this.finca.zones)) return 0;
      return this.finca.zones.filter((z) => z.variety === variety).length;
    },

    selectVariety(variety) {
      this.$root.$emit("variedad", variety);
    },
  },
};
</script>

<style scoped>
.variety-card {
  padding: 0;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  cursor: pointer;
}

.variety-body {
  padding: 20px 16px 18px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  background: rgba(255, 255, 255, 0.55);
}

.variety-name {
  margin: 0 0 6px 0;
  font-size: 20px;
  font-weight: 700;
  color: #107631;
  padding: 0;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.variety-count {
  margin: 0;
  font-size: 12px;
  color: #666;
  font-weight: 400;
}
</style>
